export default __webpack_public_path__ + "static/media/armF.8340d756.png";